import { useEffect, useState } from "react";

import { IUser } from "../../services/auth/models";
import { Typeahead } from 'react-bootstrap-typeahead';
import clsx from "clsx";
import { useGetUsersQuery } from "../../services/auth";

export const SelectUser = ({ title, value, disabled, className, onChange, onBlur }: {
    title?: string,
    value?: string,
    className?: string,
    disabled?: boolean,
    onChange: (value?: string) => void, 
    onBlur?: () => void
}) => {
    const { data, isError, isLoading, isSuccess } = useGetUsersQuery();
    const [entities, setEntities] = useState<IUser[]>([]);

    useEffect(() => {
        if (isSuccess)
            setEntities(data)
    }, [isSuccess, data])

    if (isError) {
        <span className='alert-info' style={{ display: 'block' }}>
            Failed to load users
        </span>
    }

    const handleOnChange = (selected: Record<string, any>) => {
        const value = selected[0];
        if (value)
            onChange(`${value["userId"]}`);
        else
            onChange(undefined);
    }

    return (
        <div className={clsx(className, "field-group")}>
            {title && <label className="fs-8 fw-bold text-gray-600">{title}</label>}
            <Typeahead
                id="userId"
                labelKey='userName'
                className="custom-typeahead typeahead-sm"
                isLoading={isLoading}
                clearButton={true}
                disabled={disabled}
                options={entities}
                onChange={handleOnChange}
                onBlur={onBlur}
                selected={entities?.filter(p => `${p.userId}` === value)}
            />
        </div>
    )
}